import { render, staticRenderFns } from "./CustomFieldFileUploadEditor.vue?vue&type=template&id=222a97eb&"
import script from "./CustomFieldFileUploadEditorVue.ts?vue&type=script&lang=ts&"
export * from "./CustomFieldFileUploadEditorVue.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports